import type { CreateTelegramInvoiceResponse, PremiumStatusDto, PremiumTier } from '@lingvo-news/contracts';
import { getFromApi, postToApi } from '../requests/request-helpers';

export class PremiumPaymentClient {
	constructor(private readonly baseUrl: string = '') {}

	async createTelegramInvoice(tier: PremiumTier): Promise<CreateTelegramInvoiceResponse> {
		return await postToApi<CreateTelegramInvoiceResponse>(`${this.baseUrl}/api/premium-payment/create-telegram-invoice`, { tier });
	}

	async getStatus(): Promise<PremiumStatusDto> {
		return await getFromApi<PremiumStatusDto>(`${this.baseUrl}/api/premium-payment/get-status`);
	}
}


